export const EditingStyleNameMaxLength = 255;

export function readName(value: unknown): string {
    return typeof value === 'string' ? value.trim() : '';
}

export function isValidEditingStyleName(name: string): boolean {
    const trimmedName = name.trim();

    return trimmedName !== '' && trimmedName.length <= EditingStyleNameMaxLength;
}
